import React, { useEffect, useRef, useState } from "react";
import { Button, Form, message, Input, Layout, Card, Modal, Col, Row, Space, Dropdown, Divider, InputNumber, Slider } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { getPacchetti, getPratica, getPraticaOtp, getTassi, setPacchetto } from "../services/api";
import { LoadingOutlined } from "@ant-design/icons";
import logo from "./../assets/img/BAbianco.png";
import { Colors, bp, fonts } from "../utils/constants";
import useScreenSize from "../components/useScreenSize";
import { Flex, theme, Collapse } from "antd-v5";
import { ReactComponent as SvgCard1 } from "./../assets/svg/SvgCard1.svg";
import { ReactComponent as SvgCard2 } from "./../assets/svg/SvgCard2.svg";
import { ReactComponent as SvgCard3 } from "./../assets/svg/SvgCard3.svg";
import { ReactComponent as SvgPenPaper } from "./../assets/svg/SvgPenPaper.svg";
import { ReactComponent as SvgIconDocumento } from "./../assets/svg/SvgIconDocumento.svg";
import { ReactComponent as SvgFirma } from "./../assets/svg/SvgFirma.svg";
import { ReactComponent as SvgMenu } from "./../assets/svg/SvgMenu.svg";
import { ReactComponent as SvgDoc } from "./../assets/svg/SvgDoc2.svg";
import { ReactComponent as SvgCheck } from "./../assets/svg/SvgCheck.svg";
import Azhome5 from "./../assets/img/azhome5.jpg";
import CartaDebito from "./../assets/img/carta-debito.jpg";
import ContoDeposito from "./../assets/img/conto-deposito-online4.jpg";
import { CONFIG } from "../services/config";

const { Content, Header, Footer } = Layout;

const HomeScreen = () => {
  const navigate = useNavigate();
  const in_breve = useRef(null);
  const come_aprirlo = useRef(null);
  const vantaggi = useRef(null);
  const simulatoreRef = useRef(null);
  const { token: antdToken } = theme.useToken();
  const { innerWidth, innerHeight } = useScreenSize();
  const [modalRecupera, setModalRecupera] = useState();
  const [loadingNextPage, setLoadingNextPage] = useState(false);
  const [recuperaPratica, setRecuperaPratica] = useState();
  const [recuperaOtp, setRecuperaOtp] = useState();
  const [tokenRecupera, setTokenRecupera] = useState();
  const [loading, setLoading] = useState();
  const [importoDeposito, setImportoDeposito] = useState(10000);
  const [periodoDeposito, setPeriodoDeposito] = useState(12);
  const [loadingTassi, setLoadingTassi] = useState(false);
  const [marksSlider, setMarksSlider] = useState();
  const [tassi, setTassi] = useState();
  const [isTotem, setIsTotem] = useState(false);
  const location = useLocation();

  const shortcuts = [
    { key: "1", style: { fontFamily: fonts.m }, label: <a onClick={() => in_breve.current.scrollIntoView({ behavior: "smooth", block: "start" })}>IN BREVE</a> },
    { key: "2", style: { fontFamily: fonts.m }, label: <a onClick={() => come_aprirlo.current.scrollIntoView({ behavior: "smooth", block: "start" })}>COME APRIRLO</a> },
    { key: "3", style: { fontFamily: fonts.m }, label: <a onClick={() => vantaggi.current.scrollIntoView({ behavior: "smooth", block: "start" })}>VANTAGGI</a> },
  ];

  useEffect(() => {
    setIsTotem(location?.state?.isTotem);

    try {
      setLoadingTassi(true);
      getTassi()
        .then((data) => {
          const chiaviTassi = Object.keys(data);
          const mesiArray = [0, ...data[chiaviTassi[0]].map((item) => item.mesi)];

          const oggettoChiaviValori = {};

          for (const valore of mesiArray) {
            oggettoChiaviValori[valore] = { style: { color: "#fff", fontFamily: "Poppins-SemiBold", fontSize: 12 }, label: <>{valore.toString()}</> };
          }

          setMarksSlider(oggettoChiaviValori);
          setTassi(data);
        })
        .catch((error) => {})
        .finally(() => {
          setLoadingTassi(false);
        });
    } catch (error) {}
  }, []);

  const goForward = () => {
    try {
      setLoadingNextPage(true);
      setPacchetto({ id_pacchetto: CONFIG.ID_CONTO, totem: isTotem })
        .then((res) => {
          localStorage.setItem("token", res.token);
          localStorage.setItem("id_pratica", res.id_pratica);
          if (res.totem) localStorage.setItem("praticaTotem", true);
          else localStorage.removeItem("praticaTotem");
          navigate("/conditions", { state: res.pacchetto });
        })
        .catch((error) => {})
        .finally(() => {
          setLoadingNextPage(false);
        });
    } catch (error) {
      message.error(error);
      setLoadingNextPage(false);
    }
  };

  const recuperaHandler = (value) => {
    setLoading(true);
    const data = {
      codice: value.pratica,
    };
    getPratica(data)
      .then((response) => {
        setTokenRecupera(response.token);
        setRecuperaOtp(true);
        setRecuperaPratica(false);
      })
      .catch((error) => {
        message.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const recuperaHandlerOtp = (value) => {
    setLoading(true);
    const data = {
      token_otp: tokenRecupera,
      otp: value.praticaOtp,
    };
    getPraticaOtp(data)
      .then((response) => {
        localStorage.setItem("token", response.token);
        setRecuperaOtp(false);
        localStorage.setItem("id_pratica", response.id_pratica);
        setModalRecupera();
        navigate("/onboarding");
      })
      .catch((error) => {
        message.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onChangeImportoDeposito = (value) => {
    setImportoDeposito(value);
  };

  const getTasso = () => {
    if (tassi) {
      const chiaviTassi = Object.keys(tassi);
      const tax = tassi[chiaviTassi[0]].find((tasso) => tasso.mesi === periodoDeposito);
      if (tax) {
        if (importoDeposito < parseInt(chiaviTassi[0])) {
          return tax.tasso_min.toString().replace(".", ",");
        } else {
          return tax.tasso_max.toString().replace(".", ",");
        }
      } else {
        return "0";
      }
    }
    return "0";
  };

  const getGuadagnoNetto = () => {
    if (tassi) {
      const chiaviTassi = Object.keys(tassi);
      const tax = tassi[chiaviTassi[0]].find((tasso) => tasso.mesi === periodoDeposito);
      if (tax) {
        if (importoDeposito < parseInt(chiaviTassi[0])) {
          const lordo = ((importoDeposito * tax.tasso_min) / 1200) * periodoDeposito;
          return (lordo - lordo * 0.26).toFixed(2).replace(".", ",");
        } else {
          const lordo = ((importoDeposito * tax.tasso_max) / 1200) * periodoDeposito;
          return (lordo - lordo * 0.26).toFixed(2).replace(".", ",");
        }
      } else {
        return "0";
      }
    }
    return "0";
  };

  const maxMesi = () => {
    const chiavi = Object.keys(marksSlider);
    const chiaviInt = chiavi.map((chiave) => parseInt(chiave, 10));
    const max = Math.max(...chiaviInt);
    return max;
  };

  const headerBtns = ({ primary = false, large = true } = {}) => (
    <>
      <Button size={large ? "large" : "middle"} className={`custom-btn ${primary && "custom-btn-p"}`} onClick={() => goForward()}>
        Apri il conto Online
      </Button>
      <Button
        size={large ? "large" : "middle"}
        className={`custom-btn ${primary && "custom-btn-p"}`}
        onClick={() => {
          setRecuperaPratica(true);
          setModalRecupera(true);
        }}
      >
        Recupera la tua pratica
      </Button>
    </>
  );

  return (
    <>
      {loadingNextPage ? (
        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,.5)", zIndex: 10000, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <LoadingOutlined style={{ fontSize: "64px", color: "#fff" }} />
        </div>
      ) : (
        <></>
      )}
      <Layout style={{ backgroundColor: "white", height: "100vh", overflowY: "scroll", overflowX: "hidden" }}>
        <Header style={{ backgroundColor: "#003897", position: "sticky", top: 0, zIndex: 1, width: "100%", display: "flex", alignItems: "center", paddingInline: 15, boxShadow: "0px 0px 5px 0px rgba(0,0,0,.4)" }}>
          <img src={logo} alt="Banco Azzoaglio" width={160} style={{ padding: 5, marginBottom: 5 }} />

          <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
            {innerWidth < bp.xl ? (
              <></>
            ) : (
              <Space size="small" style={{ position: "absolute", top: 0, left: 0, width: "100%", justifyContent: "center" }}>
                {shortcuts.map((link) => (
                  <Button key={link.key} type="link" style={{ color: Colors.w, ...link.style }}>
                    {link.label}
                  </Button>
                ))}
              </Space>
            )}
          </div>
          <Space size="large" align="center">
            {innerWidth < bp.md ? (
              <Dropdown
                menu={{ items: shortcuts }}
                placement="bottomRight"
                dropdownRender={(menu) => (
                  <div style={{ backgroundColor: antdToken.colorBgElevated, borderRadius: antdToken.borderRadiusLG, boxShadow: antdToken.boxShadowSecondary }}>
                    {React.cloneElement(menu, { style: { boxShadow: "none" } })}
                    <Divider style={{ margin: 0 }} />
                    <Space direction="vertical" align="center" style={{ padding: 8 }}>
                      {headerBtns({ primary: true, large: false })}
                    </Space>
                  </div>
                )}
              >
                <Button type="link" style={{ height: "100%", display: "flex", justifyContent: "center" }}>
                  <SvgMenu />
                </Button>
              </Dropdown>
            ) : (
              headerBtns()
            )}
          </Space>
        </Header>
        <Content>
          <div style={{ position: "relative", marginBottom: 30 }}>
            <div className="image-bg bg-img" />
            <div className="bg-img" style={{ backgroundColor: "#3A4F66", opacity: 0.65 }} />
            <Row style={{ minHeight: 600 }}>
              <Col xs={1} lg={4} />
              <Col xs={22} lg={8} style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <div style={{ fontFamily: fonts.b, fontSize: 18, color: Colors.w, textAlign: innerWidth < bp.lg ? "center" : "left" }}>CONTO CORRENTE ONLINE BANCO AZZOAGLIO</div>
                <div style={{ fontFamily: fonts.b, fontSize: 42, color: Colors.w, marginBlock: 20, textAlign: innerWidth < bp.lg ? "center" : "left" }}>Il conto sempre al tuo fianco, ovunque tu sia.</div>
                {innerWidth < bp.lg ? (
                  <></>
                ) : (
                  <div style={{ fontFamily: fonts.r, fontSize: 16, color: Colors.w }}>
                    Con <div style={{ fontFamily: fonts.s, display: "inline-block" }}>spese trimestrali azzerate fino ai 35 anni</div> e una piattaforma accessibile sia da <div style={{ fontFamily: fonts.s, display: "inline-block" }}>PC</div> che da
                    <div style={{ fontFamily: fonts.s, display: "inline-block" }}>smartphone</div> tramite app, hai il controllo completo delle tue finanze.
                  </div>
                )}
                <Space size="large" direction={innerWidth < bp.lg ? "vertical" : "horizontal"} align="center" style={{ marginTop: 20 }}>
                  <Button size="large" className="custom-btn custom-btn-p" style={{ borderColor: Colors.b5 }} onClick={() => goForward()}>
                    Apri adesso il conto
                  </Button>
                  <Button size="large" className="custom-btn" onClick={() => simulatoreRef.current.scrollIntoView({ behavior: "smooth", block: "start" })}>
                    Simula piano di risparmio
                  </Button>
                </Space>
              </Col>
              <Col xs={1} lg={12} />
            </Row>
          </div>

          <Flex ref={in_breve} vertical gap="large" align="center" style={{ paddingBlock: 70 }}>
            <div style={{ marginBottom: 40 }}>
              <div style={{ fontFamily: fonts.s, fontSize: 38, textAlign: "center", color: Colors.b5 }}>Conto Corrente Online Banco Azzoaglio</div>
              <div style={{ fontFamily: fonts.r, fontSize: 20, textAlign: "center" }}>
                Gestisci il tuo conto: <div style={{ fontFamily: fonts.s, display: "inline-block" }}>dove vuoi, quando vuoi.</div>
              </div>
            </div>
            <Row gutter={[15, 15]}>
              <Col xs={24} xl={8} style={{ display: "flex", justifyContent: "center" }}>
                <Card hoverable style={{ cursor: "default", width: innerWidth < bp.sm ? innerWidth - 40 : innerWidth < bp.xl ? innerWidth - 100 : 380, height: "100%", borderRadius: 10 }}>
                  <Flex vertical gap="large" align={innerWidth < bp.xl ? "center" : "start"}>
                    <div style={{ width: 70, aspectRatio: 1 }}>
                      <SvgCard1 />
                    </div>
                    <div style={{ fontFamily: fonts.s, fontSize: 20, color: Colors.b5 }}>Spese trimestrali azzerate fino ai 35 anni</div>
                    <div style={{ fontFamily: fonts.r }}>Il nostro modo di supportare la tua indipendenza finanziaria.</div>
                  </Flex>
                </Card>
              </Col>
              <Col xs={24} xl={8} style={{ display: "flex", justifyContent: "center" }}>
                <Card hoverable style={{ cursor: "default", width: innerWidth < bp.sm ? innerWidth - 40 : innerWidth < bp.xl ? innerWidth - 100 : 380, height: "100%", borderRadius: 10 }}>
                  <Flex vertical gap="large" align={innerWidth < bp.xl ? "center" : "start"}>
                    <div style={{ width: 70, aspectRatio: 1 }}>
                      <SvgCard2 />
                    </div>
                    <div style={{ fontFamily: fonts.s, fontSize: 20, color: Colors.b5 }}>Conto+Carta: la combinazione perfetta</div>
                    <div style={{ fontFamily: fonts.r }}>Con l'apertura del Conto puoi ricevere la Carta di Debito Internazionale Nexi Debit.</div>
                  </Flex>
                </Card>
              </Col>
              <Col xs={24} xl={8} style={{ display: "flex", justifyContent: "center" }}>
                <Card hoverable style={{ cursor: "default", width: innerWidth < bp.sm ? innerWidth - 40 : innerWidth < bp.xl ? innerWidth - 100 : 380, height: "100%", borderRadius: 10 }}>
                  <Flex vertical gap="large" align={innerWidth < bp.xl ? "center" : "start"}>
                    <div style={{ width: 70, aspectRatio: 1 }}>
                      <SvgCard3 />
                    </div>
                    <div style={{ fontFamily: fonts.s, fontSize: 20, color: Colors.b5 }}>Puoi scegliere di vincolare i tuoi risparmi in deposito</div>
                    <div style={{ fontFamily: fonts.r }}>Un piano di risparmio personalizzato con tassi di interesse vantaggiosi.</div>
                  </Flex>
                </Card>
              </Col>
            </Row>
          </Flex>

          <Flex ref={come_aprirlo} vertical align="center" justify="center" style={{ backgroundColor: Colors.b5, paddingBlock: innerWidth < bp.md ? 50 : 70, position: "relative" }}>
            <div className="pattern-bg bg-img" />
            <div style={{ fontFamily: fonts.m, fontSize: 32, textAlign: "center", color: Colors.w, marginBottom: 40 }}>Come aprire il Conto Corrente Online</div>
            <Row style={{ marginBottom: 20 }} gutter={[15, 15]}>
              <Col xs={24} xl={8} style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: innerWidth < bp.sm ? innerWidth - 40 : innerWidth < bp.xl ? innerWidth - 100 : 380, height: "100%", padding: 20 }}>
                  <Flex vertical gap="large" align={innerWidth < bp.xl ? "center" : "start"}>
                    <div style={{ width: 70, aspectRatio: 1 }}>
                      <SvgPenPaper />
                    </div>
                    <div style={{ fontFamily: fonts.s, fontSize: 20, color: Colors.w }}>Inserisci i dati</div>
                    <div style={{ fontFamily: fonts.r, fontSize: 16, color: Colors.w }}>Compila tutti i dati richiesti tenendo a portata di mano codice fiscale e documento d'identità.</div>
                  </Flex>
                </div>
              </Col>
              <Col xs={24} xl={8} style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: innerWidth < bp.sm ? innerWidth - 40 : innerWidth < bp.xl ? innerWidth - 100 : 380, height: "100%", padding: 20 }}>
                  <Flex vertical gap="large" align={innerWidth < bp.xl ? "center" : "start"}>
                    <div style={{ width: 70, aspectRatio: 1 }}>
                      <SvgIconDocumento />
                    </div>
                    <div style={{ fontFamily: fonts.s, fontSize: 20, color: Colors.w }}>Identificati</div>
                    <div style={{ fontFamily: fonts.r, fontSize: 16, color: Colors.w }}>Conferma la tua identità e completa la richiesta di pratica per aprire il conto online.</div>
                  </Flex>
                </div>
              </Col>
              <Col xs={24} xl={8} style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: innerWidth < bp.sm ? innerWidth - 40 : innerWidth < bp.xl ? innerWidth - 100 : 380, height: "100%", padding: 20 }}>
                  <Flex vertical gap="large" align={innerWidth < bp.xl ? "center" : "start"}>
                    <div style={{ width: 70, aspectRatio: 1 }}>
                      <SvgFirma />
                    </div>
                    <div style={{ fontFamily: fonts.s, fontSize: 20, color: Colors.w }}>Firma</div>
                    <div style={{ fontFamily: fonts.r, fontSize: 16, color: Colors.w }}>Sottoscrivi il contratto online e completa i passaggi necessari per iniziare a usare il conto.</div>
                  </Flex>
                </div>
              </Col>
            </Row>
          </Flex>

          <Flex vertical ref={vantaggi} style={{ paddingTop: 30 }}>
            <div style={{ paddingBlock: 40, display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ fontFamily: fonts.m, fontSize: 32, textAlign: "center", color: Colors.b5 }}>I vantaggi del Conto Corrente Online</div>
              <div style={{ marginTop: 15, width: 250, height: 3, backgroundColor: Colors.b5 }} />
            </div>
            <Row style={{ alignSelf: "center", paddingBlock: 20, paddingInline: innerWidth < bp.md ? 50 : 0, maxWidth: bp.xxl }}>
              <Col xs={0} lg={2} />
              <Col xs={24} lg={10} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src={Azhome5} style={{ maxWidth: 500, maxHeight: 300, width: "100%", height: "100%", borderRadius: 15 }} alt="Azhome5" />
              </Col>
              <Col xs={24} lg={10} style={{ display: "flex", justifyContent: "center", padding: 20 }}>
                <Flex vertical justify="center" gap="large">
                  <div style={{ fontFamily: fonts.b, fontSize: 18, color: Colors.b5, textAlign: innerWidth < bp.lg ? "center" : "left" }}>AZ@Home: la tua banca, ovunque tu sia.</div>
                  <div style={{ fontFamily: fonts.r, fontSize: 16, textAlign: innerWidth < bp.lg ? "center" : "left" }}>
                    Con la nostra piattaforma <div style={{ fontFamily: fonts.s, display: "inline-block" }}>AZ@Home</div>, disponibile sia come app per <div style={{ fontFamily: fonts.s, display: "inline-block" }}>smartphone</div> o accessibile da{" "}
                    <div style={{ fontFamily: fonts.s, display: "inline-block" }}>PC</div>, hai il controllo totale delle tue finanze a portata di mano.
                  </div>
                  <div style={{ fontFamily: fonts.r, fontSize: 16, textAlign: innerWidth < bp.lg ? "center" : "left" }}>
                    Puoi gestire il tuo conto in <div style={{ fontFamily: fonts.s, display: "inline-block" }}>totale autonomia</div>, con la libertà e la flessibilità che meriti. Che tu sia a casa, in ufficio o in viaggio, la tua banca è sempre con te, ovunque tu sia, in ogni momento.
                  </div>
                </Flex>
              </Col>
              <Col xs={0} lg={2} />
            </Row>
            <Row style={{ backgroundColor: "#F9FAFC", alignSelf: "center", paddingBlock: 20, paddingInline: innerWidth < bp.md ? 50 : 0, maxWidth: bp.xxl }}>
              <Col xs={0} lg={2} />
              <Col xs={24} lg={10} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src={CartaDebito} style={{ maxWidth: 500, maxHeight: 300, width: "100%", height: "100%", borderRadius: 15 }} alt="CartaDebito" />
              </Col>
              <Col xs={24} lg={10} style={{ display: "flex", justifyContent: "center", padding: 20 }}>
                <Flex vertical justify="center" gap="large">
                  <div style={{ fontFamily: fonts.b, fontSize: 18, color: Colors.b5, textAlign: innerWidth < bp.lg ? "center" : "left" }}>Carte di debito internazionale richiedibile insieme al tuo conto</div>
                  <div style={{ fontFamily: fonts.r, fontSize: 16, textAlign: innerWidth < bp.lg ? "center" : "left" }}>
                    Con l’apertura del Conto Corrente Online Banco Azzoaglio, puoi ricevere una <div style={{ fontFamily: fonts.s, display: "inline-block" }}>Carta di Debito internazionale Nexi Debit</div>®, compatibile con tutte le principali app di pagamento.
                  </div>
                  <div style={{ fontFamily: fonts.r, fontSize: 16, textAlign: innerWidth < bp.lg ? "center" : "left" }}>Questa carta ti offre una flessibilità senza precedenti nelle tue transazioni quotidiane, rendendo ogni pagamento semplice e sicuro sia in presenza che online.</div>
                </Flex>
              </Col>
              <Col xs={0} lg={2} />
            </Row>
            <Row style={{ alignSelf: "center", paddingBlock: 20, paddingInline: innerWidth < bp.md ? 50 : 0, maxWidth: bp.xxl }}>
              <Col xs={0} lg={2} />
              <Col xs={24} lg={10} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src={ContoDeposito} style={{ maxWidth: 500, maxHeight: 300, width: "100%", height: "100%", borderRadius: 15 }} alt="ContoDeposito" />
              </Col>
              <Col xs={24} lg={10} style={{ display: "flex", justifyContent: "center", padding: 20 }}>
                <Flex vertical justify="center" gap="large">
                  <div style={{ fontFamily: fonts.b, fontSize: 18, color: Colors.b5, textAlign: innerWidth < bp.lg ? "center" : "left" }}>Scegli se vincolare i tuoi risparmi in deposito</div>
                  <div style={{ fontFamily: fonts.r, fontSize: 16, textAlign: innerWidth < bp.lg ? "center" : "left" }}>
                    Hai la possibilità di <div style={{ fontFamily: fonts.s, display: "inline-block" }}>vincolare i tuoi risparmi in deposito</div> con <div style={{ fontFamily: fonts.s, display: "inline-block" }}>tassi di interesse vantaggiosi.</div> Proteggiamo il tuo capitale e gli interessi
                    maturati fino a €100.000 tramite il Fondo Interbancario di Tutela dei Depositi.
                  </div>
                  <div style={{ fontFamily: fonts.r, fontSize: 16, textAlign: innerWidth < bp.lg ? "center" : "left" }}>
                    Seleziona la durata dell’investimento, <div style={{ fontFamily: fonts.s, display: "inline-block" }}>da 3 a 60 mesi</div>, per un piano di risparmio personalizzato, beneficiando della comodità e sicurezza della piattaforma online.*
                  </div>
                  <div style={{ fontFamily: fonts.r, fontSize: 11, textAlign: innerWidth < bp.lg ? "center" : "left" }}>
                    *La liquidazione degli interessi avviene alla scadenza del vincolo di deposito, insieme al rimborso del capitale. Gli interessi netti non contemplano l’imposta di bollo per il periodo considerato. L’imposta di bollo è a carico del Cliente con addebito alla scadenza del vincolo di
                    deposito.
                  </div>
                </Flex>
              </Col>
              <Col xs={0} lg={2} />
            </Row>
          </Flex>

          <Flex ref={simulatoreRef} vertical style={{ paddingTop: 30 }}>
            <div style={{ paddingBlock: 40, display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ fontFamily: fonts.m, fontSize: 32, textAlign: "center", color: Colors.b5 }}>Simula il tuo piano di risparmio</div>
              <div style={{ marginTop: 15, width: 250, height: 3, backgroundColor: Colors.b5 }} />
            </div>
            <div style={{ alignSelf: "center", marginTop: innerWidth < bp.md ? 10 : 0, width: innerWidth < bp.md ? "90%" : "80%", flex: 1, maxWidth: bp.xxl }}>
              <div style={{ backgroundColor: "#9198b1", display: "flex", flexDirection: "column", justifyContent: "center", borderTopLeftRadius: 20, borderTopRightRadius: 20, marginBottom: "5px", padding: 15, height: 250 }}>
                <div style={{ fontFamily: "Poppins-Regular", fontSize: innerWidth < bp.md ? 12 : 20, color: "#fff", textAlign: "center", marginBottom: "10px" }}>
                  Inserisci <span style={{ fontFamily: "Poppins-Bold", fontSize: innerWidth < bp.md ? 15 : 23 }}>l'importo</span> che vorresti depositare
                </div>
                <div style={{ alignSelf: "center", display: "flex" }}>
                  <div
                    onClick={() => {
                      if (importoDeposito - 100 < 10000) setImportoDeposito(10000);
                      else setImportoDeposito(importoDeposito - 100);
                    }}
                    style={{ width: 32, height: 32, backgroundColor: "#fff", display: "flex", justifyContent: "center", alignItems: "center", color: "#9198b1", borderRadius: 40, fontSize: "14px", margin: "0 20px", cursor: "pointer", userSelect: "none", fontFamily: fonts.m }}
                  >
                    -
                  </div>
                  <InputNumber
                    defaultValue={importoDeposito}
                    value={importoDeposito}
                    formatter={(value) => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                    parser={(value) => {
                      return value.replace(/€\s?|(\.*)/g, "") || 0;
                    }}
                    onChange={onChangeImportoDeposito}
                    style={{ fontFamily: fonts.r, width: "70%", borderRadius: 20, fontSize: innerWidth < bp.md ? 12 : 20, textAlign: "center" }}
                    step={100}
                    precision={0}
                    controls={false}
                    min={10000}
                  />
                  <div
                    onClick={() => {
                      setImportoDeposito(importoDeposito + 100);
                    }}
                    style={{ width: 32, height: 32, backgroundColor: "#fff", display: "flex", justifyContent: "center", alignItems: "center", color: "#9198b1", borderRadius: 40, fontSize: "14px", margin: "0 20px", cursor: "pointer", userSelect: "none", fontFamily: fonts.m }}
                  >
                    +
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", marginTop: innerWidth < bp.md ? 10 : 20 }}>
                  <div style={{ fontFamily: "Poppins-Regular", fontSize: innerWidth < bp.md ? 12 : 20, color: "#fff", textAlign: "center" }}>
                    Seleziona la<span style={{ fontFamily: "Poppins-Bold", fontSize: innerWidth < bp.md ? 15 : 23 }}> durata (numero di mesi)</span> del vincolo
                  </div>
                  {marksSlider && (
                    <Slider
                      style={{ width: "90%", fontFamily: "Poppins-SemiBold", fontSize: innerWidth < bp.md ? 50 : 50 }}
                      marks={marksSlider}
                      step={null}
                      min={0}
                      max={maxMesi()}
                      included={false}
                      dots={false}
                      defaultValue={periodoDeposito}
                      railStyle={{ backgroundColor: "#e5e5e5" }}
                      trackStyle={{ backgroundColor: "#003897" }}
                      handleStyle={{ backgroundColor: "#003897" }}
                      tooltip={{ formatter: (value) => `${value} mesi` }}
                      labelStyle={{ color: "white" }}
                      onAfterChange={(value) => {
                        setPeriodoDeposito(value);
                      }}
                    />
                  )}
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "row", height: 150 }}>
                <div style={{ display: "flex", flex: 1, backgroundColor: "#003897", borderBottomLeftRadius: 20, flexDirection: "column", justifyContent: "space-between", marginRight: "2.5px", padding: 10 }}>
                  <div style={{ fontSize: innerWidth < bp.md ? 12 : 20, fontFamily: "Poppins-Regular", color: "#fff", textAlign: "center" }}>Depositando</div>
                  <div style={{ fontFamily: "Poppins-Bold", fontSize: innerWidth < bp.md ? 17 : 25, color: "#fff", textAlign: "center" }}>€ {importoDeposito.toLocaleString("it-IT")}</div>
                  <div style={{ fontSize: innerWidth < bp.md ? 12 : 20, fontFamily: "Poppins-Regular", color: "#fff", textAlign: "center" }}>
                    per la durata di <span style={{ fontFamily: "Poppins-Bold", fontSize: innerWidth < bp.md ? 14 : 23, marginLeft: 2 }}> {periodoDeposito} mesi</span>
                  </div>
                </div>

                <div style={{ display: "flex", flex: 1, backgroundColor: "#d1ecff", borderBottomRightRadius: 20, flexDirection: "column", justifyContent: "space-between", marginLeft: "2.5px", paddingBlock: 10 }}>
                  <div style={{ fontSize: innerWidth < bp.md ? 12 : 20, fontFamily: "Poppins-Regular", color: "#003897", textAlign: "center" }}>
                    Il tuo <span style={{ fontFamily: "Poppins-Bold", marginLeft: 2 }}>GUADAGNO</span> netto sarà pari a:
                  </div>
                  <div style={{ fontFamily: "Poppins-Bold", fontSize: innerWidth < bp.md ? 17 : 25, color: "#003897", textAlign: "center" }}>€ {getGuadagnoNetto().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</div>
                  <div style={{ fontSize: innerWidth < bp.md ? 12 : 20, fontFamily: "Poppins-Regular", color: "#003897", textAlign: "center" }}>
                    con un Tasso Lordo di <span style={{ fontFamily: "Poppins-Bold", fontSize: innerWidth < bp.md ? 14 : 23, marginLeft: 2 }}>% {getTasso()}</span>
                  </div>
                </div>
              </div>
            </div>
          </Flex>

          <Flex vertical style={{ paddingTop: 30 }}>
            <div style={{ paddingBlock: 40, display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ fontFamily: fonts.m, fontSize: 32, textAlign: "center", color: Colors.b5 }}>Dettagli dell'offerta</div>
              <div style={{ marginTop: 15, width: 250, height: 3, backgroundColor: Colors.b5 }} />
            </div>
            <Collapse
              style={{ width: innerWidth > bp.xl ? 1100 : "90%", alignSelf: "center", marginBlock: 20, fontFamily: fonts.s, color: "#003897 !important", fontSize: 15 }}
              items={[
                {
                  key: "1",
                  label: "Quanto costa il Conto Corrente Online?",
                  children: (
                    <div style={{ fontFamily: fonts.r, fontSize: 13 }}>
                      <ul>
                        <li>Canone annuo per tenuta del conto (comprensivo dell’imposta di bollo): 34,20€&nbsp;</li>
                        <li>Spese per conteggio interessi e competenze trimestrali – over 35 anni: 7,50€</li>
                        <li>Spese per conteggio interessi e competenze trimestrali – under 35 anni: 0,00€</li>
                      </ul>
                      <p>
                        <strong>In promozione:</strong>
                      </p>
                      <ul>
                        <li>Spese per conteggio e competenze trimestrali – over 35 anni (primo anno): 1,50€</li>
                      </ul>
                      <p>
                        <em>Per maggiori informazioni consultare i documenti informativi presenti al fondo della pagina.</em>
                      </p>
                    </div>
                  ),
                },
                {
                  key: "2",
                  label: "Quali sono le condizioni economiche per la funzione di vincolo?",
                  children: (
                    <div style={{ fontFamily: fonts.r, fontSize: 13 }}>
                      <ul>
                        <li>Durata del vincolo: da 3 a 60 mesi</li>
                        <li>Tasso annuo creditore: a seconda della durata (si rimanda al simulatore del piano di risparmio)</li>
                        <li>Tasso annuo per svincolo anticipato: pari al 50% del tasso creditore</li>
                        <li>Verranno riconosciuti gli interessi, calcolati al tasso indicato al netto della ritenuta, per il periodo in cui la partita è stata effettivamente in vita</li>
                        <li>I tassi creditori sono al lordo della ritenuta fiscale di legge (attualmente 26%)</li>
                        <li>Importo minimo del vincolo: 10.000€</li>
                        <li>Commissione per costituzione vincolo: 0,00€</li>
                        <li>Valuta di accredito alla scadenza del vincolo pari alla data di estinzione</li>
                        <li>Valuta di accredito in caso di estinzione anticipata del vincolo pari alla data in cui la banca riceve la richiesta del cliente</li>
                        <li>Imposta di bollo nella misura stabilita dalla legge vigente</li>
                        <li>La liquidazione degli interessi maturati sull’importo soggetto a vincolo avviene alla data di scadenza o di estinzione del vincolo</li>
                        <li>Gli interessi sono calcolati con riferimento all’anno civile (365 giorni per gli anni non bisestili e 366 per gli anni bisestili)</li>
                      </ul>
                      <p>
                        <em>Per maggiori informazioni consultare i documenti informativi presenti al fondo della pagina.</em>
                      </p>
                    </div>
                  ),
                },
                {
                  key: "3",
                  label: "Cose importanti da sapere",
                  children: (
                    <div style={{ fontFamily: fonts.r, fontSize: 13 }}>
                      <p>La richiesta di apertura di conto corrente “Io Sono Online” mono-intestato può essere effettuata dal sito internet della Banca da soggetti che rispettano i seguenti requisiti:</p>
                      <ul>
                        <li>persona fisica maggiorenne;</li>
                        <li>residenza in Italia;</li>
                        <li>persona non politicamente esposta (no PEP).</li>
                      </ul>
                      <p>Per procedere all’apertura del conto “Io Sono Online” il cliente utilizza una firma elettronica avanzata (FEA) con OTP. Il cliente deve quindi aderire alla firma elettronica avanzata (FEA) con OTP, che ne disciplina l’utilizzo.</p>
                      <p>
                        <em>Per maggiori informazioni consultare i documenti informativi presenti al fondo della pagina.</em>
                      </p>
                    </div>
                  ),
                },
              ]}
            />
          </Flex>

          <Flex vertical style={{ paddingTop: 30 }}>
            <div style={{ paddingBlock: 40, display: "flex", flexDirection: "column", alignItems: "center" }}>
              <div style={{ fontFamily: fonts.m, fontSize: 32, textAlign: "center", color: Colors.b5 }}>Documenti</div> <div style={{ marginTop: 15, width: 250, height: 3, backgroundColor: Colors.b5 }} />
            </div>
            <Row style={{ width: innerWidth > bp.xl ? 1100 : innerWidth - 100, alignSelf: "center" }}>
              <Col xs={24} lg={12}>
                <Flex vertical={innerWidth < bp.lg} align="center" gap="large" style={{ cursor: "pointer" }} onClick={() => window.open("https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/FICCONLINE.pdf", "_blank")}>
                  <div style={{ width: 50, aspectRatio: 1 }}>
                    <SvgDoc />
                  </div>
                  <div style={{ fontFamily: fonts.r, fontSize: 17, color: Colors.b5 }}>Foglio informativo Conto Corrente "Io Sono Online"</div>
                </Flex>
              </Col>
              <Col xs={24} lg={12}>
                <Flex vertical={innerWidth < bp.lg} align="center" gap="large" style={{ cursor: "pointer" }} onClick={() => window.open("https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/FIDONLINE.pdf", "_blank")}>
                  <div style={{ width: 50, aspectRatio: 1 }}>
                    <SvgDoc />
                  </div>
                  <div style={{ fontFamily: fonts.r, fontSize: 17, color: Colors.b5 }}>Documento informativo spese Conto Corrente "Io Sono Online"</div>
                </Flex>
              </Col>
              <Col xs={24} lg={12}>
                <Flex vertical={innerWidth < bp.lg} align="center" gap="large" style={{ cursor: "pointer" }} onClick={() => window.open("https://www.azzoaglio.it/assets/trasparenza/Fogli%20Informativi/FICCTDONLI.pdf", "_blank")}>
                  <div style={{ width: 50, aspectRatio: 1 }}>
                    <SvgDoc />
                  </div>
                  <div style={{ fontFamily: fonts.r, fontSize: 17, color: Colors.b5 }}>Foglio informativo Conto Deposito Online</div>
                </Flex>
              </Col>
            </Row>
          </Flex>

          <div style={{ paddingBlock: 100, display: "flex", justifyContent: "center" }}>
            <Card style={{ maxWidth: 650, marginInline: "5%", boxShadow: "0px 0px 22px 0px rgba(0, 0, 0, 0.16)", padding: innerWidth < bp.md ? 10 : 30, color: Colors.b5, fontFamily: fonts.r }}>
              <div style={{}}>
                <div style={{ fontFamily: fonts.m, fontSize: 32, textAlign: "center" }}>Il Conto Online Banco Azzoaglio è</div>
                <div>
                  <div style={{ fontFamily: fonts.s, fontSize: 32, textAlign: "center" }}>in promozione</div>
                  {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none">
                  <path d="M7.7,145.6C109,125,299.9,116.2,401,121.3c42.1,2.2,87.6,11.8,87.3,25.7"></path>
                </svg> */}
                </div>
              </div>
              <div style={{ paddingBlock: 20, fontSize: 19 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div style={{ fontFamily: fonts.m }}>Spese di apertura</div>
                  <div style={{ flex: 1, borderTop: `1px solid ${Colors.b5}`, height: 0, marginInline: 10 }} />
                  <div style={{ fontFamily: fonts.s, whiteSpace: "nowrap" }}>€ 0</div>
                </div>
                <div style={{ marginBlock: 20 }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ fontFamily: fonts.m }}>Spese trimestrali under 35</div>
                    <div style={{ flex: 1, borderTop: `1px solid ${Colors.b5}`, height: 0, marginInline: 10 }} />
                    <div style={{ fontFamily: fonts.s, whiteSpace: "nowrap" }}>€ 0</div>
                  </div>
                  <div style={{ fontSize: 11 }}>* 0€ fino al compimento dei 35 anni, poi € 7,50.</div>
                </div>
                <div style={{ marginBlock: 20 }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ fontFamily: fonts.m }}>Spese trimestrali over 35</div>
                    <div style={{ flex: 1, borderTop: `1px solid ${Colors.b5}`, height: 0, marginInline: 10 }} />
                    <div style={{ fontFamily: fonts.s, whiteSpace: "nowrap" }}>€ 1,50</div>
                  </div>
                  <div style={{ fontSize: 11 }}>* 1,50€ per il 1° anno dall'apertura, poi € 7,50.</div>
                </div>
                <div style={{ marginTop: 20, marginBottom: 40 }}>
                  <div style={{ fontFamily: fonts.m, marginBottom: 10 }}>Include:</div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ width: 20, aspectRatio: 1, marginRight: 5 }}>
                      <SvgCheck />
                    </div>
                    <div style={{ fontSize: 14 }}>Carta di Debito Internazionale Nexi Debit</div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ width: 20, aspectRatio: 1, marginRight: 5 }}>
                      <SvgCheck />
                    </div>
                    <div style={{ fontSize: 14 }}>App internet banking Azzoaglio AZ@Home</div>
                  </div>
                </div>
                <div style={{ fontSize: 11 }}>Dettaglio condizioni sul Foglio informativo</div>
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button size="large" className="custom-btn custom-btn-p" onClick={() => goForward()}>
                  Apri il Conto Online
                </Button>
              </div>
            </Card>
          </div>

          <Modal open={modalRecupera} footer={null} closable={false}>
            <div style={{ marginBottom: 80 }}>
              <div style={{ fontSize: 20, fontFamily: "Poppins-SemiBold" }}>Recupera o completa la tua pratica</div>
              {recuperaPratica && (
                <div>
                  <div style={{ marginBottom: 30, fontSize: 16, fontFamily: "Poppins-Regular", marginTop: 10 }}>Inserisci il codice per recuperare la tua pratica</div>
                  <Form onFinish={recuperaHandler}>
                    <Form.Item
                      name="pratica"
                      label={<div style={{ color: "#0A69E8", fontSize: 20, fontFamily: "Poppins-Medium" }}>Codice Pratica</div>}
                      style={{ width: "80%" }}
                      // label="Codice Pratica"
                    >
                      <Input style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: "#0061DF", fontSize: 20, fontFamily: "Poppins-Regular", marginLeft: 20 }} />
                    </Form.Item>
                    <Button type="primary" htmlType="submit" style={{ backgroundColor: "#2574F2", height: 40, width: 100, borderRadius: 6, position: "absolute", right: 20, bottom: 20 }}>
                      {loading && (
                        <div>
                          <LoadingOutlined style={{ fontSize: "24px", color: "#023AAE" }} />
                        </div>
                      )}
                      {!loading && <div style={{ fontSize: 16, fontFamily: "Poppins-Regular" }}>AVANTI</div>}
                    </Button>
                  </Form>
                </div>
              )}
              {recuperaOtp && (
                <div>
                  <div style={{ marginBottom: 30, fontSize: 16, fontFamily: "Poppins-Regular", marginTop: 10 }}>Inseriscil'otp che hai ricevuto via email</div>
                  <Form onFinish={recuperaHandlerOtp}>
                    <Form.Item name="praticaOtp" label={<div style={{ color: "#0A69E8", fontSize: 20, fontFamily: "Poppins-Medium" }}>OTP Pratica</div>} style={{ width: "80%" }}>
                      <Input style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: "#0061DF", fontSize: 20, fontFamily: "Poppins-Regular", marginLeft: 20 }} />
                    </Form.Item>
                    <Button type="primary" htmlType="submit" style={{ backgroundColor: "#2574F2", height: 40, width: 100, borderRadius: 6, position: "absolute", right: 20, bottom: 20 }}>
                      {loading && (
                        <div>
                          <LoadingOutlined style={{ fontSize: "24px", color: "#023AAE" }} />
                        </div>
                      )}
                      {!loading && <div style={{ fontSize: 16, fontFamily: "Poppins-Regular" }}>AVANTI</div>}
                    </Button>
                  </Form>
                </div>
              )}
              <Button
                onClick={() => {
                  setRecuperaOtp();
                  setRecuperaPratica();
                  setModalRecupera();
                }}
                style={{ height: 40, width: 100, borderRadius: 6, position: "absolute", right: 135, bottom: 20 }}
              >
                <div style={{ fontSize: 16, fontFamily: "Poppins-Regular" }}>CHIUDI</div>
              </Button>
            </div>
          </Modal>

          <Footer style={{ backgroundColor: "#102136", display: "flex", justifyContent: "center" }}>
            <p style={{ fontFamily: fonts.r, fontSize: 10, textAlign: "center", color: Colors.darkBlue }}>
              Banco di Credito P. Azzoaglio S.p.A.
              <br />
              Sede legale: 12073 Ceva (CN) - Via A. Doria, 17 - Capitale Sociale euro 25.500.000 interamente versato.
              <br />
              Registro Imprese di Cuneo n. 00166050047 - Registro Unico degli intermediari assicurativi (RUI) Sez. D n°: D000027031 - REA 1368 - Albo Banche 1717/8
              <br />
              Cod. fisc. e P.IVA: 00166050047 - Aderente al Fondo Interbancario di Tutela dei Depositi - Codice destinatario fatturazione elettronica (SDI): IOPVBGU
              <br />
            </p>
          </Footer>
        </Content>
      </Layout>
    </>
  );
};

export default HomeScreen;
